import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ErrorNote from '../common/util/ErrorNote'
import SuccessNote from '../common/util/SuccessNote'
import { getAtomicAsset } from '../helpers/Api'
import { AssetButtonWrapper } from './AssetButtonWrapper'
import AssetDetails from './AssetDetails'
import { AssetImage } from './AssetImage'
import { AssetTitle } from './AssetTitle'
import { AssetTransactions } from './AssetTransactions'
import PriceHistory from './PriceHistory'
import BuyOfferBox from './BuyOfferBox'

export const AssetView = ({
    asset,
    newOwner,
    children,
    isLoading,
    buttons,
    auctionDetails,
    warning,
    selectedAsset = 0,
}) => {
    const { t } = useTranslation('common')

    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(false)

    const dismissError = () => {
        setError(null)
    }

    const dismissMessage = () => {
        setSuccess(false)
    }

    const { price, assets, seller } = asset

    const { backedTokens, assetId, template } = assets
        ? assets[selectedAsset]
        : asset

    const [atomicAssetData, setAtomicAssetData] = useState(null)

    const parseAtomicAssetData = (res) => {
        if (res && res['success']) setAtomicAssetData(res['data'])
    }

    useEffect(() => {
        if (assetId) {
            getAtomicAsset(assetId).then(parseAtomicAssetData)
        }
    }, [assetId])

    return (
        <div className={'w-full px-2 lg:px-4 bg-red'}>
            <div className={'flex flex-wrap'}>
                <div
                    className={cn(
                        'relative flex flex-wrap w-full h-auto my-auto',
                    )}
                >
                    <div className="w-full h-full lg:w-1/2">
                        <AssetImage
                            asset={assets ? assets[selectedAsset] : asset}
                            atomicAssetData={atomicAssetData}
                            title={
                                auctionDetails && assets && assets.length > 1
                                    ? t('search.auction_by_x_bundle_y', {
                                          x: seller,
                                          y: assets.length,
                                      })
                                    : auctionDetails
                                    ? t('search.auction_by_x', { x: seller })
                                    : price && assets && assets.length > 1
                                    ? t('search.listing_by_x_bundle_y', {
                                          x: seller,
                                          y: assets.length,
                                      })
                                    : price && (!assets || assets.length === 1)
                                    ? t('search.listing_by_x', { x: seller })
                                    : 'Asset'
                            }
                        />
                        <div
                            className={cn(
                                'hidden lg:block border dark:!bg-paper bg-zinc-200 rounded-md shadow-xl',
                                'border-zinc-200 dark:!border-paperl p-5 mt-4',
                            )}
                        >
                            {isLoading || !template?.templateId ? null : (
                                <BuyOfferBox
                                    asset={
                                        assets ? assets[selectedAsset] : asset
                                    }
                                />
                            )}
                        </div>
                        <div
                            className={cn(
                                'hidden lg:block border dark:!bg-paper bg-zinc-200 rounded-md shadow-xl',
                                'border-zinc-200 dark:!border-paperl p-5 mt-4',
                            )}
                        >
                            {isLoading ? null : (
                                <PriceHistory assetId={assetId} />
                            )}
                        </div>
                    </div>
                    <div className="w-full h-auto lg:w-1/2">
                        <AssetTitle
                            asset={assets ? assets[selectedAsset] : asset}
                        />
                        {buttons ? (
                            <AssetButtonWrapper
                                buttons={buttons}
                                warning={warning}
                                auctionDetails={auctionDetails}
                            />
                        ) : (
                            ''
                        )}
                        <AssetDetails
                            asset={assets ? assets[selectedAsset] : asset}
                            newOwner={newOwner}
                            auctionDetails={auctionDetails}
                            buttons={buttons}
                            backedTokens={backedTokens}
                        />
                        <AssetTransactions assetId={asset.assetId} />
                        <div
                            className={cn(
                                'block lg:hidden border dark:!bg-paper bg-zinc-200 rounded-md shadow-xl',
                                'border-zinc-200 dark:!border-paperl p-5 mt-4',
                            )}
                        >
                            {isLoading ? null : (
                                <PriceHistory assetId={asset.assetId} />
                            )}
                        </div>
                    </div>
                </div>
                <div>
                    {error ? (
                        <ErrorNote error={error} onClick={dismissError} />
                    ) : (
                        ''
                    )}
                    {success && (
                        <div className={'relative'}>
                            <SuccessNote
                                error={'Featured!'}
                                onClick={dismissMessage}
                            />
                        </div>
                    )}
                </div>
            </div>
            {children}
        </div>
    )
}

export default AssetView
